import React from 'react';
import moment from 'moment';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Authorization from 'containers/Authorization';
import { BUILDER } from 'shared/abilities';
import classes from './BuildInfo.scss';

function renderTooltip(buildName, timestamp) {
  return (
    <Tooltip id="build-info" className={classes.tooltip}>
      <div className={classes.title}>Build Info</div>
      <div>
        <i className="fa fa-fw fa-hashtag" />
        {' '}
        <code>{buildName}</code>
      </div>
      <div>
        <i className="fa fa-fw fa-clock-o" />
        {' '}
        {moment(timestamp).format('YYYY-MM-DD HH:mm:ss')}
      </div>
    </Tooltip>
  );
}

const BuildInfo = () => {
  const buildName = process.env.BUILD_NAME;
  const timestamp = process.env.BUILD_TIMESTAMP;

  if (!buildName || !timestamp) {
    return null;
  }

  return (
    <Authorization action="manage" subject={BUILDER}>
      {authorized => authorized &&
        <OverlayTrigger placement="top" overlay={renderTooltip(buildName, timestamp)}>
          <i className={`fa fa-wrench ${classes.icon}`} />
        </OverlayTrigger>
      }
    </Authorization>
  );
};
BuildInfo.propTypes = {};

export default BuildInfo;
